import {
  CancelBookingCancellerEnum,
  InvoiceStatus
} from '@link/supplier/services/const';

export default {
  layouts: {
    sidebar: {
      notifications: '알림',
      contractsList: '계약 관리',
      activitiesManagement: '상품 관리',
      activities: '상품 목록',
      allotmentSettings: '재고 설정',
      backendSettings: '백엔드 재고 설정',
      backendCalendar: '캘린더',
      settings: '설정',
      changePassword: '비밀번호 변경',
      suppliers: '공급사 관리',
      suppliersDetail: '회사 정보',
      suppliersAccount: '계정 관리',
      info: '기본 정보',
      detail: '상세 정보',
      agent: '가격 그룹 설정',
      i18n: '다국어 설정',
      planInfo: '플랜 - {{title}}',
      bookingInfoSettings: '예약 정보 설정',
      price: '유닛/요금 설정',
      addPlan: '플랜 추가',
      editMemo: '메모 편집',
      editLog: '편집 이력',
      adminSetting: '관리자 설정',
      adminPlanInfo: '플랜 - {{title}} 설정',
      adminActivity: '상품 설정',
      allotmentSetting: '영업일·기본 재고 설정',
      allotmentSegmentId: '시작 시간 ID 추가',
      allotmentException: '예외 시작 시간 설정',
      allotmentCalendar: '캘린더 편집',
      allotmentOtaGroup: 'OTA 재고 그룹 설정',
      allotmentBackend: '백엔드 설정',
      booking: '예약',
      unprocessedList: '미처리 목록',
      finance: '결제 관리',
      bulkOrder: '일괄 주문',
      dataExport: '데이터 출력'
    }
  },
  views: {
    dataExport: {
      period: '기간',
      dataExport: '데이터 출력',
      bookingData: '예약 데이터',
      dateMode: '날짜 모드',
      byBookingDate: '예약일 기준',
      byParticipationDate: '참가일 기준',
      outputMode: '출력 형식',
      byBookings: '예약 기준',
      byTravelers: '여행자 기준',
      status: '상태',
      download: '파일 다운로드',
      today: '오늘',
      yesterday: '어제',
      oneWeek: '1주일',
      thisMonth: '이번 달',
      lastMonth: '지난달'
    },
    bulkBookingDetail: {
      history: '작업 내용',
      action: '작업',
      operator: '작업자',
      date: '날짜',
      message: '메시지',
      notifyConfirmed: '송금 승인',
      paymentDate: '송금일',
      paymentConfirmed: '송금을 승인했습니다',
      infoSentToSupplier: '정보는 OTA로 전송되었습니다'
    },
    dashboard: {
      title: '대시보드'
    },
    activities: {
      templateSource: '상품',
      heading: '상품 목록',
      status: '상태',
      title: '상품명',
      inputSupplierTitle: '상품명을 입력해 주세요',
      addActivity: '상품 등록',
      edit: '편집',
      confirmed: '상품 설정 완료, 공개 가능합니다',
      name: '상품명',
      list: '상품 목록',
      addNewActivity: '신규 상품 등록',
      add: '등록',
      selectSupplier: '공급사 선택',
      copyTitle: '상품 복사',
      selectSupplierLabel: '공급사 선택',
      copy: '복사',
      copyModalTitle: '복사-{{text}}',
      export: '다운로드',
      isBulkOrder: '일괄 주문'
    },
    backendSettings: {
      newTitle: '신규 Backend 재고 설정',
      management: '재고 등록',
      poolId: '관리 ID',
      supplierId: '공급사명',
      name: '관리명',
      confirm: '확정',
      state: '상태',
      status: '상태',
      lastExecution: '이전 업데이트',
      nextExecution: '다음 업데이트',
      jobStatus: {
        success: '성공',
        failed: '실패'
      }
    },
    activity: {
      mergePlanError: '상품에 기존 플랜이 있는 경우 가져오기를 금지합니다',
      importError: '파일 형식 또는 내용에 문제가 있습니다',
      import: '가져오기',
      title: '상품',
      log: {
        logHistory: '상품 편집 이력',
        priceHistory: '가격 그룹 편집 이력',
        chooseLog: '이력 선택',
        chooseItemLabel: '플랜 {{index}} 편집 이력',
        html: 'HTML 로그',
        by: 'by'
      },
      memo: {
        title: '편집용 메모',
        tips: '편집용 메모는 상품 편집 시 기록용으로, OTA 또는 직판 사이트에는 표시되지 않습니다',
        successUpdated: '메모를 저장했습니다'
      },
      tag: {
        title: '편집용 태그',
        tips: '편집용 태그는 상품 편집 시 기록용으로, OTA 또는 직판 사이트에는 표시되지 않습니다'
      },
      paymentCollector: '수금처',
      productDescription: '상품 설명',
      priceSetting: '결제 통화 설정',
      autoPublic: '자동 공개 설정',
      autoPublicGroup: '대상 그룹 선택',
      imageSetting: '이미지 설정',
      participantNotice: '참가 전후 주의사항(포함 사항 등)',
      agentGroupName: '가격 그룹명',
      agentSaved: 'OTA를 저장했습니다',
      agentSetting: '가격 그룹 설정',
      addAgentGroup: '가격 그룹 추가',
      agentTips:
        '※ 가격 그룹은 각 OTA의 가격 설정과 연동되므로 하나의 OTA를 여러 그룹에 추가할 수 없습니다.',
      comment: '코멘트',
      publishedApplied: '공개 신청했습니다',
      rejectApplied: '반려되었습니다',
      approved: '승인했습니다',
      published: '공개했습니다',
      publish: '공개',
      publishToNeoOnly: 'NEO에만 공개',
      publishToNextOnly: 'NEXT(현행 시스템)에만 공개',
      reject: '반려',
      approve: '공개 승인',
      submit: '공개 신청',
      save: '저장',
      preview: '미리 보기',
      productPreview: '상품 미리보기',
      voucherPreview: 'Voucher 미리보기',
      applyForPublish: '상품 공개 신청',
      productConfirmationMessage:
        '등록하신 상품 내용과 플랜을 확인 후 상품을 공개해 주세요',
      confirmPermission: '권한이 없습니다',
      confirmReject: '승인 반려',
      confirmApprovalOfProduct: '상품 공개 승인',
      productContentConfirmed: '상품 내용을 확인했습니다',
      confirmForPublishingProducts: '상품 공개 확인',
      productPublishedConfirmed: '상품 공개를 승인했습니다',
      productSaved: '상품을 저장했습니다',
      languageSetting: '다국어 설정',
      languageSelection: '언어 선택',
      productTitle: '상품명(바우처 표시명)',
      origin: '출발지',
      destination: '목적지',
      checkinPoints: '집합 장소',
      checkoutPoints: '해산 장소',
      pickupLocation: '픽업 장소',
      dropoffLocations: '하차 장소',
      cancellationPolicy: '취소 정책',
      faqSetting: 'FAQ 설정',
      chosenLanguage: '게시 언어',
      timeZone: '국가·지역 (시간대)',
      category: '카테고리',
      useQrCode: 'QR 코드 사용',
      qrcodeType: 'QR 코드 타입',
      qrcodeDisplayLocations: 'QR 코드 표시 위치',
      voucherSetting: '바우처 설정',
      voucherVersion: '바우처 버전',
      appointmentSetting: '예약 설정',
      appointmentNotification: '예약 알림',
      useEticketItems: 'E-티켓 이용 항목',
      qrcodeTemplate: 'QR 코드 템플릿',
      qrcodeHeader: 'QR 코드 헤더',
      qrcodeFooter: 'QR 코드 푸터',
      qrcodeGenerator: 'QR 코드 생성기',
      redemptionUrlTemplate: '교환 URL 템플릿',
      adminSettingSaved: '관리자 설정을 저장했습니다',
      allotmentSettingSaved: '플랜 설정을 저장했습니다',
      planSelection: '플랜 선택',
      planId: '플랜 ID',
      systemCharge: '시스템 수수료',
      productInfo: '상품 정보',
      supplierId: '공급사(ID)',
      supplierName: '공급사명',
      name: '상품명',
      editMemo: '편집용 메모',
      editTag: '편집용 태그',
      publishActivityConfirm: '이 상품을 공개하시겠습니까?',
      publishActivitySuccess:
        '※ 상품 공개 시 가격 설정에 추가된 OTA 계정에서 상품 정보를 열람할 수 있습니다',
      inPublish: '공개 중',
      isActivityPublished: '상품을 공개했습니다',
      isActivityPublishedFailed: '상품 공개에 실패했습니다',
      contactUs: '번거로우시겠지만 담당자에게 연락해 주세요',
      leaveCurrentPage: '이 페이지에서 나가기',
      continueEditing: '편집 계속',
      salesStatus: '상품 표시',
      hideFromSearch: '상품 목록 표시',
      salesStatusNotes: '※ 상품 표시 상태를 변경한 경우 재공개가 필요합니다',
      hideFromSearchNotes:
        '※ 목록 표시를 OFF로 설정하면 검색 결과 및 상품 목록에 표시되지 않습니다',
      qrCodeTips:
        '※ ‘인원별 QR 코드 발행’ 또는 ‘모기리 이용’ 설정은 담당자에게 문의해 주세요'
    },
    allotmentSettings: {
      heading: '영업일・기본 재고 설정',
      title: '재고 설정',
      new: '재고 등록',
      poolId: '관리 ID',
      supplierId: '공급사명',
      name: '관리용 재고명',
      inputAllotmentName: '관리용 재고명을 입력해 주세요',
      leaveCurrentPage: '이 페이지에서 나가기',
      continueEditing: '편집 계속',
      edit: {
        name: '재고',
        createTitle: '신규 재고 등록',
        copyTitle: '재고 복사'
      },
      form: {
        id: '재고 ID',
        name: '관리용 재고명',
        freesale: '프리 세일',
        copyCalendarEdits: '캘린더 편집 복사',
        add: '일반 재고 추가'
      },
      exception: {
        name: '특정일 시작 시간 설정',
        default: '일반 재고',
        allowedDefault: '이용 가능',
        disallowedDefault: '이용 불가',
        defaultApplicable: '(일반 재고 설정 적용: {{applicable}})',
        applicable: '적용',
        notApplicable: '미적용'
      },
      segmentId: {
        name: '시작 시간 ID',
        addPrompt: '시작 시간 ID 추가',
        refTime: '참고 시간',
        startTimeIdRequired: '시작 시간 ID를 입력해 주세요',
        startTimeRequired: '시작 시간을 입력해 주세요'
      },
      otaGroup: {
        name: 'OTA 재고 그룹 설정',
        groupName: 'OTA 재고 그룹명',
        addPrompt: 'OTA 재고 설정 추가',
        addOta: 'OTA 추가',
        deleteOta: 'OTA 삭제'
      },
      backendBundle: {
        backendOption: '백엔드',
        bundleOption: '번들',
        backendId: '백엔드 재고 ID',
        bundleChildAllotmentPoolId: '관련 자상품 재고 ID',
        parentStartTimeId: '시작 시간 재고 ID',
        refTime: '참고 시간',
        childStartTimeId: '하위상품 시작 시간 재고 ID',
        addPrompt: '관련 자상품 ID 추가',
        label: '백엔드 선택',
        bundleStartTimeSetting: '시작 시간 ID 설정',
        segmentTime: '시작 시간 ID',
        childSegmentTimeId: '하위상품 시작 시간 ID',
        backendAllotment: '백엔드 재고 설정',
        bundleAddPrompt: '번들용 재고 설정 추가',
        bundleGroupHeaderText: '관련 자상품 ID'
      }
    },
    agentGroup: {
      addAgent: 'OTA 추가',
      deleteAgent: 'OTA 삭제'
    },
    plan: {
      title: '플랜',
      saveConfirm: '플랜을 저장했습니다',
      name: '플랜명',
      planPublish: '플랜 노출 표시',
      bookingRule: '예약 설정',
      voucherExpiration: '바우처 유효기간',
      expirationVisibilitySetting: '바우처 유효기간 숨기기',
      visibilitySetting: {
        hideFromVoucher: '바우처에 비표시',
        hideFromActivityDetails: '웹페이지에서 숨김(상품 내용)',
        hideFromBookingDetails: '웹페이지에서 숨김(예약 상세)'
      },
      checkinPoint: '집합 장소',
      checkoutPoint: '해산 장소',
      pickupLocation: '픽업 장소',
      dropoffLocation: '하차 장소',
      unitSetting: '유닛 설정',
      priceSetting: '요금 설정',
      bookingAgentRequiredInfo: '대표자 정보-예약별(필수)',
      bookingAgentRecommendedInfo: '대표자 정보-예약별(선택)',
      bookingOtherRequiredInfo: '기타 정보-예약별(필수)',
      bookingOtherRecommendedInfo: '기타 정보-예약별(선택)',
      participantRequiredInfo: '이용자 정보-참가자별(필수)',
      participantRecommendedInfo: '이용자 정보-참가자별(선택)',
      customBookingInfo: '커스텀 예약 정보',
      settingUnable: '종료일은 시작일 이전으로 설정할 수 없습니다',
      description: '플랜 설명',
      imageSetting: '이미지 설정',
      availablePeriod: '공개 기간',
      reservationRestrict: '예약 수량 제한',
      pieces: '장',
      min: '최소',
      max: '최대',
      tilde: '~',
      checklistLabel: '참가 전·참가 시 주의사항(포함 사항 등)',
      startTime: '시작 시간',
      setSchedule: '일정 설정',
      editConfirm: '편집 확인',
      leave: '이 페이지에서 나가기',
      continueEditing: '편집 계속',
      code: {
        id: '플랜 ID',
        coupon: '번들 자식 상품 바우처 숨김',
        backendId: '재고 설정 ID',
        backendIdLabel: '재고 설정을 선택해 주세요',
        goToSetting: '미설정인 경우 <0>여기</0>에서 설정해 주세요',
        backend: '백엔드 정보',
        backendLabel: '연동할 Backend를 선택해 주세요',
        productCode: '상품 코드',
        productCodeLabel: '상품 코드를 입력해 주세요',
        unit: '유닛 설정',
        unitType: '유닛 종류',
        unitRange: '단위 범위',
        unitCode: '유닛 코드',
        startTimeTitle: '시작 시간 설정',
        startTime: '시작 시간',
        startTimeCode: '시작 시간 코드',
        codeLabel: '코드를 입력해 주세요',
        linkToAllotment: '재고 설정에 연결'
      },
      planPublishNotes: '※ 플랜 표시 상태 변경 시 상품 재공개가 필요합니다',
      duplicatePlan: '플랜 복제',
      ruleDeadlineDayNotes:
        '※ 예약 기한에 "0" 입력 시 당일부터 계산되며 당일 포함됩니다',
      voucherExpirationNotes:
        '※ 유효기간에 "1" 입력 시 당일부터 계산되며 당일 포함됩니다. "0" 입력 시 즉시 만료되니 주의해 주세요'
    },
    bookingTodos: {
      title: '미처리 목록',
      count: '건',
      within24Hours: '24시간 이내',
      within5Days: '5일 이내',
      within7Days: '7일 이내',
      over7Days: '7일 이상',
      purchasedDate: '결제 신청일',
      productPlan: '상품/플랜',
      bookerName: '예약자명',
      deadline: '마감',
      timeRemaining: '마감까지 남은 시간',
      timeRemainingFormat: '{{hours}}시간 {{minutes}}분 {{seconds}}초'
    },
    bookingDetail: {
      requestPanelTitle: '예약 목록 응답',
      applicationDate: '신청일시',
      deadlineLabel: '마감',
      accept: '승인',
      deny: '접수 불가',
      rejects: '거부',
      denyReasonPlaceholder: '거부 사유를 입력해 주세요',
      actionTitle: '귀하는 이 예약 요청을 {{action}}했습니다'
    },
    bookingCancel: {
      form: '취소 양식',
      canceller: '취소 사유',
      reason: '사유',
      comment: '코멘트',
      cancellationFee: '취소 수수료',
      time: '현재 날짜·시간',
      money: '금액',
      refundAllSystemFee: '시스템 수수료 전액 환불',
      discount: 'X',
      percentFormula: '% =',
      pleaseSetCancelFee: '취소 수수료를 설정해 주세요'
    },
    financeHistory: {
      title: '결제 내역',
      dataAggregation: '데이터 집계',
      aggregationUnit: '집계 단위',
      targetPeriod: '대상 기간',
      monthly: '월간',
      weekly: '주간',
      confirmed: '확정 완료',
      canceledRefund: '취소자',
      differenceAdjusted: '차액 조정 완료',
      totalAmount: '합계 금액',
      cancellationFee: '(내 취소 수수료)',
      serviceFee: '시스템 수수료',
      totalPaymentAmount: '결제 금액 합계',
      price: '({{currency}})',
      salesPrice: '판매 가격',
      wholesalePrice: '도매가',
      commission: '커미션',
      transactionSearch: '예약 검색',
      applicationDate: '신청일',
      participationDate: '참가일',
      transactionStatus: '예약 상태',
      keyword: '키워드',
      activity: '상품',
      plan: '플랜',
      supplier: '공급사',
      reservationNumber: '예약번호',
      currency: '통화'
    },
    financeTransactions: {
      title: '정산서',
      transactionStatus: '정산 상태',
      keyword: 'ID 검색',
      difference: '차액 조정',
      dueDate: '청구서 발행일',
      invoiceNumber: '청구 ID',
      date: '청구 시기',
      fromDate: '{{fromDate}}~{{toDate}}',
      currency: '통화 단위',
      amount: '결제 금액 합계',
      adjustedAmount: '조정 금액',
      finalAmount: '최종 합계 금액',
      showjust: '표시',
      change: '입금 완료',
      invoice: '청구 내역',
      jaInvoice: '일본어 청구서',
      jaInvoiceDetails: '명세서(일본어)',
      enInvoice: '영문 청구서',
      enInvoiceDetails: '명세서(영문)',
      attachment: '첨부 파일',
      changeTitle: '입금 완료되었습니까?',
      changeMessage: '거래 상태는 “입금 완료”로 변경됩니다'
    }
  },
  common: {
    activityId: '템플릿 ID',
    search: '검색',
    leaveCurrentPageConfirm: `{{name}}은 아직 편집 중입니다. 이 페이지를 나가시겠습니까?`,
    successCreatedMsg: '{{name}} 추가 성공',
    errorCreatedMsg: '{{name}} 추가 실패',
    successDeletedMsg: '{{name}} 삭제 성공',
    errorDeletedMsg: '{{name}} 삭제 실패',
    successUpdatedMsg: '{{name}} 업데이트 성공',
    errorUpdatedMsg: '{{name}} 업데이트 실패',
    sharedAllotment: '공유 재고',
    colon: ':'
  },
  const: {
    cancelBookingCanceller: {
      [CancelBookingCancellerEnum.Supplier]: '공급사',
      [CancelBookingCancellerEnum.SupplierForTraveler]: '고객'
    },
    templateStatus: {
      DRAFT: '임시 저장',
      REVIEWING: '공개 신청 중',
      APPROVED: '공개 확인 완료',
      PUBLISHED: '공개 완료(NEXT만)',
      NEO_PUBLISHED: '공개 완료(NEO만)',
      BOTH_PUBLISHED: '공개 완료(NEO・NEXT)'
    },
    jobState: {
      ENABLED: '성공',
      PAUSED: '중지',
      DISABLED: '무효',
      UPDATE_FAILED: '업데이트 실패',
      ERROR: '오류'
    },
    universalType: {
      TRUE: '각 플랜 공통',
      FALSE: '각 플랜 상이'
    },
    voucherType: {
      NONE: '불필요',
      COLLECTIVE: '예약별 QR 코드',
      INDIVIDUAL: '1인 1 QR 코드'
    },
    qrcodeType: {
      QRCODE: 'QR 코드',
      TEXT: '텍스트',
      URL: 'URL',
      BARCODE_128: 'BARCODE_128',
      BARCODE_93: 'BARCODE_93',
      BARCODE_39: 'BARCODE_39',
      BARCODE_25: 'BARCODE_25'
    },
    qrcodeDisplayLocation: {
      QR_CODE_DISPLAY_LOCATION_VOUCHER: '바우처',
      QR_CODE_DISPLAY_LOCATION_ETICKET_PORTAL_SITE: 'E-티켓 표시 사이트'
    },
    voucherMedium: {
      ELECTRONIC: '인쇄 불필요(화면 제시)',
      PAPER: '인쇄 필수'
    },
    voucherVersion: {
      VOUCHER_VERSION_V1: 'V1',
      VOUCHER_VERSION_V2: 'V2'
    },
    formatType: {
      BEFORE_ACTIVITY_FORWARD_FIXED_CLOCK:
        '이용/참가일 {{D}}일 전 현지 시간 {{HH:MM}} 이후 취소 시 예약 총액의 {{N}} 취소 수수료가 발생합니다',
      BEFORE_ACTIVITY_FORWARD_DURATION:
        '이용/참가 시간 {{T}}시간 전 이후 취소 시 예약 총액의 {{N}} 취소 수수료가 발생합니다',
      AFTER_BOOKING_FORWARD_DURATION:
        '예약 확정 후 {T}시간 이후 예약 총액의 {N} 취소 수수료가 발생합니다.',
      AFTER_BOOKING_FORWARD_FIXED_CLOCK:
        '예약 확정일을 0일째로, {D}일째 현지 시간 {HH:MM} 이후 예약 총액의 {N} 취소 수수료가 발생합니다.',
      BEFORE_ACTIVITY_BACKWARD_FIXED_CLOCK:
        '이용/참가일 {{D}}일 전 현지 시간 {{HH:MM}}까지 예약 총액의 {{N}} 취소 수수료가 발생합니다',
      BEFORE_ACTIVITY_BACKWARD_DURATION:
        '이용/참가 시간 {{T}}시간 전까지 예약 총액의 {{N}} 취소 수수료가 발생합니다',
      AFTER_BOOKING_BACKWARD_DURATION:
        '예약 확정 후 {T}시간 전까지 예약 총액의 {N} 취소 수수료가 발생합니다.',
      AFTER_BOOKING_BACKWARD_FIXED_CLOCK:
        '예약 확정일을 0일째로, {D}일째 현지 시간 {HH:MM}까지 예약 총액의 {N} 취소 수수료가 발생합니다.'
    },
    cancellationFeeType: {
      PERCENTAGE: '퍼센트',
      ADVANCED_PERCENTAGE: '고급 백분율 설정',
      FIXED: '정액 요금',
      NOT_CANCELLABLE: '취소 불가'
    },
    basePrice: {
      GROSS: '판매 가격',
      NET: '도매가',
      SUPPLIER_NET: '공급사 도매 가격'
    },
    confirmationType: {
      FREE_SALE: '참가일 지정(프리세일)',
      FREE_SALE_OPEN_DATE: '참가일 지정 불필요(프리세일)',
      INVENTORY: '참가일 지정(즉시 확인)',
      REQUEST: '참가일 지정(요청)'
    },
    datePeriodUnit: {
      DAY: '일수 계산',
      MONTH: '월 수 계산'
    },
    datePeriod: {
      DAY: '일간',
      MONTH: '개월',
      tilde: '~'
    },
    collectingType: {
      PER_PARTICIPANT: '참가자별',
      PER_BOOKING: '예약별'
    },
    collectingTiming: {
      ON_BOOKING: '예약 시 필요',
      BEFORE_ACTIVITY: '참가일까지 필요',
      OPTIONAL: '선택 사항'
    },
    formType: {
      DATE_ONLY_PAST: '날짜(과거만)',
      DATE_ONLY_FUTURE: '날짜(미래만)',
      TIME: '시간',
      YES_NO: '예/아니오',
      DROPDOWN: '드롭다운 선택',
      RADIO: '라디오 버튼',
      CHECK: '체크박스',
      TEXT: '텍스트',
      TEXT_ALPHANUMERIC: '텍스트(영숫자)',
      TEXT_PHONE: '전화번호',
      TEXTAREA: '텍스트 영역'
    },
    voucherExpirationType: {
      FROM_PURCHASE_DATE: '구입일부터',
      FROM_ACTIVITY_DATE: '참가일로부터',
      FIXED_DATE: '절대 고정일',
      RELATIVE_FIXED_DATE: '상대 고정일'
    },
    unit: {
      AGE_ADULT_AND_CHILD: '성인·아동 공통 ({n}-{m})세',
      AGE_ADULT: '성인 ({n}-{m})세',
      AGE_YOUTH: '청소년 ({n}-{m})세',
      AGE_CHILD: '아동 ({n}-{m})세',
      AGE_SENIOR: '시니어 ({n}-{m})세',
      AGE_INFANT: '유아({n}-{m})세',
      AGE_STUDENT: '학생 ({n}-{m})세',
      AGE_HIGH_SCHOOL: '고등학생({n}-{m})세',
      AGE_INTERMEDIATE_SCHOOL: '중학생 ({n}-{m})세',
      AGE_ELEMENTALY_SCHOOL: '초등학생 ({n}-{m})세',
      AGE_COLLEGE: '대학생 ({n}-{m})세',
      AGE_GRADUATE: '대학원생 ({n}-{m})세',
      AGE_DISABLED_ADULT: '장애인 - 성인({n}-{m})세',
      AGE_DISABLED_YOUTH: '장애인 - 청소년({n}-{m})세',
      AGE_DISABLED_CHILD: '장애인 - 어린이({n}-{m})세',
      AGE_SUPPORTER_ADULT: '보호자(성인)',
      AGE_SUPPORTER_CHILD: '보호자(아동)',
      MINUTES_VEHICLES: '{n}분',
      HOURS_VEHICLES: '{n}시간',
      DAYS_VEHICLES: '{n}일',
      WEEKS_VEHICLES: '{n}주',
      NIGHTS_VEHICLES: '{n}박',
      CHARTER_VAR: '1대({n}-{m})인',
      GROUP_VAR: '1그룹({n}-{m})인',
      ROOM_VAR: '1실({n}-{m})인',
      BOAT_VAR: '1대({n}-{m})인',
      PET: '애완동물',
      PET_CAT: '고양이',
      PET_DOG: '개',
      PET_DOG_S: '소형견',
      PET_DOG_M: '중형견',
      PET_DOG_L: '대형견',
      PET_DOG_XL: '초대형견',
      PET_OTHER: '기타 반려동물',
      AGE_ADULT_AND_CHILD_2: '일반',
      AGE_CHILD_2: '소인',
      DRINK_STANDARD_SET: 'THE ROOF SEAT & STANDARD SET',
      DRINK_CHAMPAGNE_SET: 'THE ROOF SEAT & CHAMPAGNE SET',
      QUANTITY: '1개'
    },
    invoiceStatus: {
      [InvoiceStatus.InvoiceStatusPending]: '입금 대기',
      [InvoiceStatus.InvoiceStatusConfirmed]: '입금 완료',
      [InvoiceStatus.InvoiceStatusPaid]: '입금 확인 중',
      [InvoiceStatus.InvoiceStatusCancelled]: '취소 완료'
    },
    activityTags: {
      NON_CANCELLABLE: '취소 불가',
      FREE_CANCEL_BEFORE_ISSUE_TICKET: '교환 전 취소 무료',
      ADVANCE_CANCELLATION_POLICY: '특별 취소 정책',
      INSTANT_BOOK: '즉시 예약',
      NON_QR_CODE: '실물 바우처',
      QR_CODE: 'QR 바우처',
      ETICKET: '모기리 티켓(스마트폰 필요)'
    }
  },
  lang: {
    en: '영어',
    ja: '일본어',
    zh: '중국어(간체)',
    zt: '중국어(번체)',
    ko: '한국어'
  },
  component: {
    location: {
      title: '{{label}} 명칭',
      address: '주소',
      placeId: '장소 ID',
      latlong: '위도·경도',
      select: '{{label}} 선택',
      errMsg:
        '검색 결과가 없습니다. 입력 내용을 다시 확인하거나 지도에서 직접 선택해 주세요'
    },
    checklist: {
      notice: '주의사항 {{index}}',
      selectNoticePrompt: '참가 전·참가 시 주의사항을 선택해 주세요',
      uploadPDF: 'PDF 업로드',
      uploadImage: '이미지 업로드',
      googleMapSetting: 'Google 지도 설정'
    },
    cancel: {
      notCancellable: '예약 후 취소 및 변경은 불가합니다',
      freeCancellable: '교환 전까지 무료 취소 가능. 교환 후에는 환불 불가',
      flex: '고급 취소 정책을 설정합니다.',
      preview: '미리보기',
      cancelPreview: '취소 정책 미리보기',
      info: '커스텀 설명문',
      timeSetting: '취소 일시 설정',
      day: '일 {D}',
      timeFormat: '시간 {HH:MM}',
      time: '시간 {T}',
      feeSetting: '취소 수수료 설정',
      feeSettingPrompt: '취소 수수료 설정을 선택해 주세요',
      cancelPolicyPrompt: '취소 정책을 선택해 주세요',
      priceReferenceSale: '가격 기준: 판매가',
      priceReference: '가격 기준:',
      fromClient: '여행자로부터 (%)',
      fromAgent: 'OTA로부터 (%)',
      toSupplier: '공급사에 (%)',
      paymentCancelFee: '취소 수수료 결제',
      fromClientToAgent: '여행자 → OTA',
      fromAgentToLinktivity: 'OTA가 LINKTIVITY에',
      fromLinktivityToSupplier: 'LINKTIVITY에서 공급사로'
    },
    rule: {
      type: '예약 유형',
      possibleInterval: '예약 가능 기간',
      interval: '예약 접수 마감일',
      daysBefore: '며칠 전',
      timeBefore: '~시까지'
    },
    faq: {
      question: '질문',
      answer: '답변',
      faqTitle: '항목 {{index}}'
    },
    voucher: {
      incrementDate: '연도 증가 기준일'
    },
    startTime: {
      id: 'ID',
      name: '시작 시간',
      title: '제목',
      poolId: '시작 시간 ID'
    },
    itinerary: {
      title: '제목',
      detailedSchedule: '일정 상세'
    },
    additional: {
      id: '예약 정보 ID',
      title: '예약 정보 제목',
      info: '예약 정보 설명',
      setting: '예약 정보 설정 방법',
      deadline: '답변 마감',
      answerType: '답변 형식',
      selectItems: '선택 항목',
      selectPrompt: '선택해 주세요'
    },
    price: {
      info: '가격 {{index}}',
      reservableInterval: '예약 가능 기간',
      startTime: '시작 시간',
      endTime: '종료 시간',
      unitType: '유닛 종류',
      unitPrice: '판매 단가',
      soldPrice: '판매 가격',
      agentPrice: '도매가',
      comission: '커미션',
      price: '요금',
      accuracy: '정확도',
      rate: '요율',
      comissionRate: '커미션율(표시용)',
      comissionRateTips:
        '명세서 및 서식 등에 표시되는 환율 항목에는 이 환율이 표시됩니다',
      auto: '속도 정밀도 설정',
      applicableSetting: '적용 기간 설정',
      applicableInterval: '적용 기간',
      applicableDates: '적용 요일',
      otherApplicableDates: '기타 적용일',
      unitRange: '단위 범위',
      standardPrice: '표준 가격',
      numberIncluded: '정원 포함',
      soloPurchase: '단독 구매'
    },
    backendForm: {
      cloudSchedulerJob: '동기화 ID',
      state: '상태',
      status: '상태',
      lastExecution: '이전 업데이트',
      nextExecution: '다음 업데이트',
      selectSupplier: '공급사 선택',
      name: '관리명',
      backendPoolId: '백엔드 재고 관리 ID',
      backend: '백엔드 정보',
      selectBackendPlaceholder: '연동할 Backend를 선택해 주세요',
      supplierPoolId: '공급자 Pool ID',
      scheduleTimezone: '업데이트 타임존',
      schedule: '업데이트 스케줄',
      scheduleNote: '※ 기재 방법은 여기를 참고해 주세요.'
    },
    dateSetting: {
      titlePlaceholder: '재고 관리명을 입력해 주세요',
      name: '일반 재고 설정',
      interval: '적용 기간(요일)',
      exactDates: '특정일',
      commonAllotment: '재고 설정',
      add: '일반 재고 패턴 추가',
      common: '공통',
      freesale: '프리세일',
      createTitle: '재고 패턴 설정',
      modal: {
        interval: '적용 기간',
        dates: '적용 요일',
        otaAllotments: 'OTA 재고 설정'
      }
    },
    editAllotment: {
      type: '유형',
      amountReserved: '예약 수량',
      amountEdited: '재고 수량',
      amountRemains: '남은 재고',
      shared: '공유 재고'
    },
    calendar: {
      groupRule: '재고 표시',
      week: '주',
      month: '월',
      showMore: '자세히',
      amountReserved: '실제 예약 수',
      amountLimit: '최대 예약 수',
      edited: '캘린더 편집에서 설정됨',
      notice: {
        title: '이 페이지에서 재고 수를 직접 변경할 때는 주의해 주세요.',
        orderLabel: '일반적인 설정 순서:',
        orderValue: '【영업일·기본 재고 설정】→【예외 시작 시간 설정】',
        tempLabel: '임시 조정 / 긴급 마감:',
        tempValue: '【캘린더 편집】에서 직접 변경할 수 있습니다.',
        priorityLabel: '우선순위 규칙:',
        priorityValue:
          '【캘린더 편집】(최우선) → 【예외 시작 시간 설정】(중) → 【영업일·기본 재고 설정】(기본)',
        remark:
          '※【캘린더 편집】에서 재고를 설정하면 해당 시간대의 일반 설정 및 예외 설정은 자동으로 무효가 되며, 【캘린더 편집】의 수치가 적용됩니다.'
      }
    },
    segmentId: {
      name: '시작 시간 ID',
      addPrompt: '시작 시간 ID 추가',
      refTime: '참고 시간',
      startTimeIdRequired: '시작 시간 ID를 입력하세요.',
      startTimeRequired: '시작 시간을 입력해 주세요'
    }
  }
};
